var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapDiv",class:{'mapshow': _vm.opacityFlag, 'maphidden': !_vm.opacityFlag}},[_c('div',{staticClass:"close"},[_c('i',{on:{"click":_vm.closeClick}},[_c('van-icon',{attrs:{"name":"cross"}})],1)]),_c('div',{attrs:{"id":"allmap"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }